import { createFileRoute } from "@tanstack/react-router";
import { ServicePage, buildServiceMeta } from "@/components/ServicePage";
import { commercialContent } from "@/data/serviceContent";

const slug = "post-construction";
const c = commercialContent[slug];

export const Route = createFileRoute("/commercial/post-construction")({
  head: () => buildServiceMeta({
    title: c.title,
    description: c.intro[0].slice(0, 155),
    path: "/commercial/post-construction",
  }),
  component: () => <ServicePage category="commercial" slug={slug} {...c} />,
});
